import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NAV_ITEMS } from './navigation';
import { can } from '@/lib/permissions';
import type { Role } from '@/types/domain';
import { cn } from '@/lib/cn';

/** Mobile bottom navigation — impeccable mobile view (5 primary modules). */
export function MobileNav({ role }: { role: Role }) {
  const { t } = useTranslation();
  const items = NAV_ITEMS.filter((i) => !i.capability || can(role, i.capability)).slice(0, 5);

  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 lg:hidden">
      <div className="glass-strong mx-3 mb-3 flex items-center justify-around rounded-2xl px-2 py-2">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              cn(
                'flex flex-1 flex-col items-center gap-1 rounded-xl px-1 py-1.5 text-[10px] transition-colors',
                isActive ? 'text-primary' : 'text-muted-foreground',
              )
            }
          >
            <item.icon className="h-5 w-5" />
            <span className="truncate">{t(item.labelKey)}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
